/**
 * GTM dataLayer event tracking.
 *
 * All events are pushed through a single delegated listener rather than inline
 * handlers, so markup stays clean and dynamically rendered nodes (Alpine
 * templates, modals) are covered without re-binding.
 *
 * Elements opt in with data attributes:
 *   data-gtm-event="<event_name>"       required — the dataLayer event name
 *   data-gtm-success="<event_name>"     alternative — fires once on page load,
 *                                       for server-rendered form success states
 *   data-gtm-*="<value>"                optional — extra params, camelCased
 *
 * Example: data-gtm-event="add_to_quote_list" data-gtm-product-name="Compass"
 * pushes { event: 'add_to_quote_list', productName: 'Compass' }.
 */

window.dataLayer = window.dataLayer || [];

function gtmPush(payload) {
  window.dataLayer.push(payload);
}

// Collect data-gtm-* attributes (excluding data-gtm-event) into a params object.
function gtmParams(el) {
  const params = {};
  for (const { name, value } of el.attributes) {
    // Skip the two attributes that carry the event NAME rather than a param.
    if (
      !name.startsWith('data-gtm-') ||
      name === 'data-gtm-event' ||
      name === 'data-gtm-success'
    ) {
      continue;
    }
    const key = name
      .slice('data-gtm-'.length)
      .replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    params[key] = value;
  }
  return params;
}

// Delegated click tracking for anything carrying data-gtm-event.
document.addEventListener(
  'click',
  (event) => {
    const el = event.target.closest('[data-gtm-event]');
    if (!el) return;
    gtmPush({ event: el.dataset.gtmEvent, ...gtmParams(el) });
  },
  { capture: true }
);

// Programmatic hook for events fired from JS (form success, etc.).
window.gtmTrack = function (name, params) {
  gtmPush({ event: name, ...(params || {}) });
};

// Server-rendered form successes: a [data-gtm-success] element is only present
// in the DOM once Shopify has actually accepted the submission.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gtm-success]').forEach((el) => {
    gtmPush({ event: el.dataset.gtmSuccess, ...gtmParams(el) });
  });
});
